import { PriceInterval } from '@griply/types';
import { createContext } from 'react';

export type PremiumDialogContextProps = {
  openPremiumDialog: (priceInterval?: PriceInterval) => void;
};

export const PremiumDialogContext = createContext<PremiumDialogContextProps>({
  openPremiumDialog: () => {},
});
